import Suru from "../../../../suru/js/app";

$(document).ready(function(){
	Suru.forms();
    var terms = $(".cookie-settings-page .error-hide");
    terms.hide();
    
    $(".forms").submit(function() {
        return $("#terms").is(":checked") ? !false : (terms.show(), terms.addClass("forms-error"),
        !true)
    });
});